/**
 * EPMS-86: open the Klaviyo Customer Hub directly on Chat.
 *
 * Triggers: any element with [data-open-chat] (branded launcher, announcement bar
 * blocks) or any link whose href ends in "#chat" (menus, rich text), e.g.
 * "#chat" or "/pages/contact#chat".
 *
 * If the Hub hasn't loaded for this visitor, real links (e.g. "/pages/contact#chat")
 * are followed as normal; anything else goes to the fallback URL.
 */
(() => {
  const fallbackUrl = document.currentScript?.dataset.fallbackUrl || '/pages/contact';
  const TRIGGER_SELECTOR = '[data-open-chat], a[href$="#chat"]';
  const NATIVE_LAUNCHER_SELECTOR = '.kl-hub-launcher-container';
  const READY_POLL_MS = 500;
  const READY_TIMEOUT_MS = 30000;

  const isHubReady = () => typeof window.customerHubApi?.open === 'function';

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(TRIGGER_SELECTOR);
    if (!trigger) return;

    if (isHubReady()) {
      event.preventDefault();
      window.customerHubApi.open('/chat');
      return;
    }

    const href = trigger.getAttribute('href');
    if (href && !href.startsWith('#')) return;

    event.preventDefault();
    window.location.href = fallbackUrl;
  });

  // Reveal the branded launcher only once Klaviyo has loaded the Hub and rendered its
  // own launcher, so Klaviyo's display/targeting rules still decide who sees chat.
  const launcher = document.querySelector('[data-chat-launcher]');
  if (!launcher) return;

  const startedAt = Date.now();
  const revealWhenReady = () => {
    if (isHubReady() && document.querySelector(NATIVE_LAUNCHER_SELECTOR)) {
      launcher.hidden = false;
      return;
    }
    if (Date.now() - startedAt < READY_TIMEOUT_MS) {
      setTimeout(revealWhenReady, READY_POLL_MS);
    }
  };
  revealWhenReady();
})();
